<template>
  <v-dialog v-model="showing_academic_modal" persistent eager max-width="650">
    <v-card>
      <v-form
        ref="form"
        v-model="academic_form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-card-title class="headline">
          {{ $t("config_academic.config_academic") }} (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("config_academic.addnew")
              : $t("config_academic.edit")
          }}
          )
        </v-card-title>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-bind:label="$t('config_academic.year')"
                v-model="configAcademic_year"
                type="number"
                outlined
                dense
                v-bind:rules="configAcademicRules"
            /></v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-autocomplete
                v-model="configAcademic_semester"
                v-bind:label="$t('config_academic.semester')"
                v-bind:items="semesters"
                v-bind:item-value="(item) => item.semester"
                v-bind:item-text="(item) => item.semester"
                v-bind:rules="requiredRules"
                outlined
                dense
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="12">
              <DateSelectCard
                v-model="configAcademic_startSystemDate"
                v-bind:label="$t('config_academic.start_datetime_system')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startAcademicDate"
                v-bind:label="$t('config_academic.start_datetime_academic')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endAcademicDate"
                v-bind:label="$t('config_academic.end_datetime_academic')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startTeachTableDate"
                v-bind:label="
                  $t('config_academic.start_datetime_config_teach_table')
                "
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endTeachTableDate"
                v-bind:label="
                  $t('config_academic.end_datetime_config_teach_table')
                "
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startMidtermDate"
                v-bind:label="$t('config_academic.start_datetime_midterm')"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endMidtermDate"
                v-bind:label="$t('config_academic.end_datetime_midterm')"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startFinalDate"
                v-bind:label="$t('config_academic.start_datetime_final')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endFinalDate"
                v-bind:label="$t('config_academic.end_datetime_final')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row v-if="configAcademic_levelId == '1'">
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startPreRegisDate"
                v-bind:label="$t('config_academic.start_datetime_pre_regis')"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endPreRegisDate"
                v-bind:label="$t('config_academic.end_datetime_pre_regis')"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startRegisDate"
                v-bind:label="$t('config_academic.start_datetime_regis')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endRegisDate"
                v-bind:label="$t('config_academic.end_datetime_regis')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startAddChangeDate"
                v-bind:label="$t('config_academic.start_datetime_add_change')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endAddChangeDate"
                v-bind:label="$t('config_academic.end_datetime_add_change')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_startWithdrawDate"
                v-bind:label="$t('config_academic.start_datetime_withdraw')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configAcademic_endWithdrawDate"
                v-bind:label="$t('config_academic.end_datetime_withdraw')"
                v-bind:rules="requiredRules"
                v-bind:maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>

        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn color="success" dark @click="form_validate()">
            {{ $t("config_academic.save") }}</v-btn
          >
          <v-btn color="error" dark @click="showing_academic_modal = false">{{
            $t("config_academic.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { objectTranslator } from "@/helper/translator";
import DateSelectCard from "@/components/info_cards/DateSelect";

// import { objectTranslator } from "@/helper/translator";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";

import dayjs from "dayjs";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigAcademic",
  props: {
    toggle_loading: Function,
  },
  data: () => {
    return {
      FORM_MODES,
      semesters: ["1", "2", "3"],
      levels: [
        {
          LEVEL_ID: "1",
          LEVEL_NAME_EN: "ปริญญาตรี",
          LEVEL_NAME_TH: "ปริญญาตรี",
        },
        {
          LEVEL_ID: "2",
          LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
          LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
        },
      ],
      form_mode: null,
      academic_form_status: null,
      showing_academic_modal: false,

      configAcademic_id: null,
      configAcademic_year: null,
      configAcademic_semester: null,
      configAcademic_levelId: null,
      configAcademic_subLevelId: null,
      configAcademic_startSystemDate: null,
      configAcademic_startAcademicDate: null,
      configAcademic_endAcademicDate: null,
      configAcademic_startTeachTableDate: null,
      configAcademic_endTeachTableDate: null,
      configAcademic_startMidtermDate: null,
      configAcademic_endMidtermDate: null,
      configAcademic_startFinalDate: null,
      configAcademic_endFinalDate: null,
      configAcademic_startPreRegisDate: null,
      configAcademic_endPreRegisDate: null,
      configAcademic_startRegisDate: null,
      configAcademic_endRegisDate: null,
      configAcademic_startAddChangeDate: null,
      configAcademic_endAddChangeDate: null,
      configAcademic_startWithdrawDate: null,
      configAcademic_endWithdrawDate: null,

      configAcademicRules: [validator.required, validator.thaiYear],
      requiredRules: [validator.required],
    };
  },
  components: {
    DateSelectCard,
  },
  computed: {
    ...mapOfficerConfigFields({
      config_academics: "config_academics",
    }),
  },
  methods: {
    objectTranslator,
    getYearsModified,

    open_add_modal: function(level_id) {
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      this.configAcademic_levelId = level_id;
      this.showing_academic_modal = true;
    },
    open_edit_modal: function(item) {
      this.form_mode = FORM_MODES.EDIT;
      this.configAcademic_id = item.ID;
      this.configAcademic_year = item.YEAR;
      this.configAcademic_semester = item.SEMESTER;
      this.configAcademic_levelId = item.LEVEL_ID;
      this.configAcademic_subLevelId = item.SUB_LEVEL_ID;
      this.configAcademic_startSystemDate = item.START_DATETIME_SYSTEM;
      this.configAcademic_startAcademicDate = item.START_DATETIME_ACADEMIC;
      this.configAcademic_endAcademicDate = item.END_DATETIME_ACADEMIC;
      this.configAcademic_startTeachTableDate =
        item.START_DATETIME_CONFIG_TEACH_TABLE;
      this.configAcademic_endTeachTableDate =
        item.END_DATETIME_CONFIG_TEACH_TABLE;
      this.configAcademic_startMidtermDate = item.START_DATETIME_MIDTERM;
      this.configAcademic_endMidtermDate = item.END_DATETIME_MIDTERM;
      this.configAcademic_startFinalDate = item.START_DATETIME_FINAL;
      this.configAcademic_endFinalDate =
        item.END_DATETIME_FINAL === "0000-00-00 00:00:00"
          ? null
          : item.END_DATETIME_FINAL;
      this.configAcademic_startPreRegisDate = item.START_DATETIME_PRE_REGIS;
      this.configAcademic_endPreRegisDate = item.END_DATETIME_PRE_REGIS;
      this.configAcademic_startRegisDate = item.START_DATETIME_REGIS;
      this.configAcademic_endRegisDate = item.END_DATETIME_REGIS;
      this.configAcademic_startAddChangeDate = item.START_DATETIME_ADD_CHANGE;
      this.configAcademic_endAddChangeDate = item.END_DATETIME_ADD_CHANGE;
      this.configAcademic_startWithdrawDate = item.START_DATETIME_WITHDRAW;
      this.configAcademic_endWithdrawDate = item.END_DATETIME_WITHDRAW;
      this.showing_academic_modal = true;
    },
    form_validate: function() {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },
    add_form_validate: async function() {
      this.$refs.form.validate();
      if (this.academic_form_status) {
        this.showing_academic_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .setAcademics({
            level_id: this.configAcademic_levelId,
            sub_level_id: this.configAcademic_subLevelId,
            year: this.configAcademic_year,
            semester: this.configAcademic_semester,

            start_system_date:
              dayjs(this.configAcademic_startSystemDate).format("YYYY-MM-DD") +
              " 00:00:00",

            start_academic_date:
              dayjs(this.configAcademic_startAcademicDate).format(
                "YYYY-MM-DD"
              ) + " 00:00:00",
            end_academic_date:
              dayjs(this.configAcademic_endAcademicDate).format("YYYY-MM-DD") +
              " 23:59:59",
              
            //
            start_teach_table_date: this.configAcademic_startTeachTableDate
              ? dayjs(this.configAcademic_startTeachTableDate).format(
                  "YYYY-MM-DD"
                ) + " 00:00:00"
              : "0000-00-00 00:00:00",
            end_teach_table_date: this.configAcademic_endTeachTableDate
              ? dayjs(this.configAcademic_endTeachTableDate).format(
                "YYYY-MM-DD"
              ) + " 23:59:59"
              : "0000-00-00 00:00:00",
            //

            start_midterm_date: this.configAcademic_startMidtermDate
              ? dayjs(this.configAcademic_startMidtermDate).format(
                  "YYYY-MM-DD"
                ) + " 00:00:00"
              : "0000-00-00 00:00:00",
            end_midterm_date: this.configAcademic_endMidtermDate
              ? dayjs(this.configAcademic_endMidtermDate).format("YYYY-MM-DD") +
                " 23:59:59"
              : "0000-00-00 00:00:00",

            start_final_date:
              dayjs(this.configAcademic_startFinalDate).format("YYYY-MM-DD") +
              " 00:00:00",
            //
            end_final_date: this.configAcademic_endFinalDate
            ? dayjs(this.configAcademic_endFinalDate).format("YYYY-MM-DD") +
              " 23:59:59"
              : "0000-00-00 00:00:00",

            start_pre_regis_date: this.configAcademic_startPreRegisDate
              ? dayjs(this.configAcademic_startPreRegisDate).format(
                  "YYYY-MM-DD"
                ) + " 08:30:00"
              : "0000-00-00 00:00:00",
            end_pre_regis_date: this.configAcademic_endPreRegisDate
              ? dayjs(this.configAcademic_endPreRegisDate).format(
                  "YYYY-MM-DD"
                ) + " 16:30:00"
              : "0000-00-00 00:00:00",

            start_regis_date:
              dayjs(this.configAcademic_startRegisDate).format("YYYY-MM-DD") +
              " 08:30:00",
            end_regis_date:
              dayjs(this.configAcademic_endRegisDate).format("YYYY-MM-DD") +
              " 16:30:00",

            start_add_change_date:
              dayjs(this.configAcademic_startAddChangeDate).format(
                "YYYY-MM-DD"
              ) + " 08:30:00",
            end_add_change_date:
              dayjs(this.configAcademic_endAddChangeDate).format("YYYY-MM-DD") +
              " 16:30:00",

            start_withdraw_date:
              dayjs(this.configAcademic_startWithdrawDate).format(
                "YYYY-MM-DD"
              ) + " 08:30:00",
            end_withdraw_date:
              dayjs(this.configAcademic_endWithdrawDate).format("YYYY-MM-DD") +
              " 16:30:00",
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getAcademics");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.create_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_create"));

        this.toggle_loading(false);
      }
    },
    edit_form_validate: async function() {
      this.$refs.form.validate();
      if (this.academic_form_status) {
        this.showing_academic_modal = false;
        this.toggle_loading(true);

        let response = await configService
          .setAcademics({
            // id: this.configAcademic_id,
            level_id: this.configAcademic_levelId,
            year: this.configAcademic_year,
            sub_level_id: this.configAcademic_subLevelId,
            semester: this.configAcademic_semester,

            start_system_date:
              dayjs(this.configAcademic_startSystemDate).format("YYYY-MM-DD") +
              " 00:00:00",

            start_academic_date:
              dayjs(this.configAcademic_startAcademicDate).format(
                "YYYY-MM-DD"
              ) + " 00:00:00",
            end_academic_date:
              dayjs(this.configAcademic_endAcademicDate).format("YYYY-MM-DD") +
              " 23:59:59",

            start_teach_table_date:
              dayjs(this.configAcademic_startTeachTableDate).format(
                "YYYY-MM-DD"
              ) + " 00:00:00",
            end_teach_table_date:
              dayjs(this.configAcademic_endTeachTableDate).format(
                "YYYY-MM-DD"
              ) + " 23:59:59",

            start_midterm_date:
              this.configAcademic_startMidtermDate &&
              this.configAcademic_startMidtermDate !== "0000-00-00 00:00:00"
                ? dayjs(this.configAcademic_startMidtermDate).format(
                    "YYYY-MM-DD"
                  ) + " 00:00:00"
                : "0000-00-00 00:00:00",
            end_midterm_date:
              this.configAcademic_endMidtermDate &&
              this.configAcademic_endMidtermDate !== "0000-00-00 00:00:00"
                ? dayjs(this.configAcademic_endMidtermDate).format(
                    "YYYY-MM-DD"
                  ) + " 23:59:59"
                : "0000-00-00 00:00:00",

            start_final_date:
              dayjs(this.configAcademic_startFinalDate).format("YYYY-MM-DD") +
              " 00:00:00",
            end_final_date:
              dayjs(this.configAcademic_endFinalDate).format("YYYY-MM-DD") +
              " 23:59:59",

            start_pre_regis_date:
              this.configAcademic_startPreRegisDate &&
              this.configAcademic_startPreRegisDate !== "0000-00-00 00:00:00"
                ? dayjs(this.configAcademic_startPreRegisDate).format(
                    "YYYY-MM-DD"
                  ) + " 08:30:00"
                : "0000-00-00 00:00:00",
            end_pre_regis_date:
              this.configAcademic_endPreRegisDate &&
              this.configAcademic_endPreRegisDate !== "0000-00-00 00:00:00"
                ? dayjs(this.configAcademic_endPreRegisDate).format(
                    "YYYY-MM-DD"
                  ) + " 16:30:00"
                : "0000-00-00 00:00:00",

            start_regis_date:
              dayjs(this.configAcademic_startRegisDate).format("YYYY-MM-DD") +
              " 08:30:00",
            end_regis_date:
              dayjs(this.configAcademic_endRegisDate).format("YYYY-MM-DD") +
              " 16:30:00",

            start_add_change_date:
              dayjs(this.configAcademic_startAddChangeDate).format(
                "YYYY-MM-DD"
              ) + " 08:30:00",
            end_add_change_date:
              dayjs(this.configAcademic_endAddChangeDate).format("YYYY-MM-DD") +
              " 16:30:00",

            start_withdraw_date:
              dayjs(this.configAcademic_startWithdrawDate).format(
                "YYYY-MM-DD"
              ) + " 08:30:00",
            end_withdraw_date:
              dayjs(this.configAcademic_endWithdrawDate).format("YYYY-MM-DD") +
              " 16:30:00",
          })
          .catch((error) => {
            this.$toasted.error(JSON.stringify(error.response.data.message), {
              duration: 0,
            });
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getAcademics");
        if (response && response.status)
          this.$toasted.success(this.$t("toasted.edit_successfully"));
        else this.$toasted.error(this.$t("toasted.cannot_edit"));

        this.toggle_loading(false);
      }
    },
  },
  mounted: function() {},
};
</script>
